// import React from 'react'
// import { useDispatch, useSelector } from "react-redux";
// import { BarChart, Bar, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';
// import { useFetchData } from "../../../../hooks/useFtechData";
// import { JOBSEEKER_URL } from "../../../../resources/resource";
// import { useState, useRef } from "react";
// import { useMakeRequest } from '../../../../hooks/useMakeRequest';
// import { toast } from 'react-toastify';
// import { uploadToCloudinary } from '../../../../Utils/cloudinaryUpload';
// import { updateUser } from '../../../../redux/users/userSlice'
// import FaceAuth from '../../FaceAuth';
// import LoadSpinner from '../../../../component/Modals/LoadSpinner';
// import { FaCamera } from "react-icons/fa6";
// import DefaultProfile from "../../../../assets/Images/employee.png"
// import axios from 'axios';
// import { Spinner } from 'flowbite-react';
// import { race } from '../../data';
// import { Link } from 'react-router-dom';
// const Profile = () => {

//       const dispatch = useDispatch();
//       const { currentUser, token } = useSelector((state) => state.user);
//       const loggedInUser = useSelector((state) => state.user);
//       console.log(loggedInUser)
//         const fileInputRef = useRef();
//         const makeRequest = useMakeRequest();
//         const votersCardInputRef = useRef();
//         const residentialCardInputRef = useRef();
//         const scanningEvidenceInputRef = useRef();
//         const tenancyAgreementInputRef = useRef();
      
//       const { data: userDetails, refetch: refetchUser } = useFetchData(
//         JOBSEEKER_URL + `/getAjobSeeker/${loggedInUser?.currentUser?._id}`
//       );
//       console.log(userDetails)
//         const [showForm, setShowForm] = useState(false);
//         const [changeListener, setChangeListener] = useState(false);
//         const [loadingUpdate, setLoadingUpdate] = useState(false);
//         const [loadingImageUpload, setLoadingImageUpload] = useState(false);
//         const [loadingNINVerification, setLoadingNINVerification] = useState(false);
//         const [ninVerificationStatus, setNINVerificationStatus] = useState(null);
//         const [previewImage, setPreviewImage] = useState(null);
//         const [votersCardPreview, setVotersCardPreview] = useState(null);
//         const [residentialCardPreview, setResidentialCardPreview] = useState(null);
//         const [scanningEvidencePreview, setScanningEvidencePreview] = useState(null);
//         const [tenancyAgreementPreview, setTenancyAgreementPreview] = useState(null);
//         const [imageChange, setImageChange] = useState(false);
//         const [votersCard, setVotersCard] = useState(null);
//         const [residentialCard, setResidentialCard] = useState(null);
//         const [scanningEvidence, setScanningEvidence] = useState(null);
//         const [tenancyAgreement, setTenancyAgreement] = useState(null);
//         const [imageFile, setImageFile] = useState(null);
//         const [faceData, setFaceData] = useState(null);
//         const [profileInfo, setProfileInfo] = useState({
//           jobSeekerId: loggedInUser?.currentUser?._id,
//           nin: '',
//         });

      
//       const userId = localStorage.getItem('userId');
//       console.log(userId);
//   console.log(profileInfo)


//         const handleProfileChange = (e) => {
//           setProfileInfo({
//             ...profileInfo,
//             [e.target.name]: e.target.value,
//             jobSeekerId: loggedInUser.currentUser._id,
//           });
        
//           setChangeListener(true);
//         };
      
      
      
        
      
      
      
      
      
//          const handleAvatar = async (e, fileType) => {
//           const file = e.target.files[0];
//           if (!file) return;
      
//           switch (fileType) {
//             case "avatar":
//               setImageFile(file);
//               setPreviewImage(URL.createObjectURL(file));
//               break;
//             case "votersCard":
//               setVotersCard(file);
//               setVotersCardPreview(URL.createObjectURL(file));
//               break;
//             case "residentialCard":
//               setResidentialCard(file);
//               setResidentialCardPreview(URL.createObjectURL(file));
//               break;
//             case "scanningEvidence":
//               setScanningEvidence(file);
//               setScanningEvidencePreview(URL.createObjectURL(file));
//               break;
//             case "tenancyAgreement":
//               setTenancyAgreement(file);
//               setTenancyAgreementPreview(URL.createObjectURL(file));
//               break;
//             default:
//               break;
//           }
//           setImageChange(true);
//         };
      
//         const handleUpdateImage = async () => {
//           // if (!imageFile && !votersCard && !residentialCard && !scanningEvidence && !tenancyAgreement) {
//           //   return toast.error("Kindly select at least one file to upload");
//           // }
           
//           if (!imageFile && !votersCard && !residentialCard && !scanningEvidence && !tenancyAgreement && !faceData) {
//             return toast.error('Kindly select at least one file or complete face authentication to upload');
//           }
//           setLoadingImageUpload(true);
//           try {
//             const payload = {};
//             if (imageFile) {
//               const imageURL = await uploadToCloudinary(imageFile);
//               if (imageURL) payload.avatar = imageURL;
//             }
//             if (votersCard) {
//               const votersCardURL = await uploadToCloudinary(votersCard);
//               if (votersCardURL) payload.votersCard = votersCardURL;
//             }
//             if (residentialCard) {
//               const residentialCardURL = await uploadToCloudinary(residentialCard);
//               if (residentialCardURL) payload.residentialCard = residentialCardURL;
//             }
//             if (scanningEvidence) {
//               const scanningEvidenceURL = await uploadToCloudinary(scanningEvidence);
//               if (scanningEvidenceURL) payload.scanningEvidence = scanningEvidenceURL;
//             }
//             if (tenancyAgreement) {
//               const tenancyAgreementURL = await uploadToCloudinary(tenancyAgreement);
//               if (tenancyAgreementURL) payload.tenancyAgreement = tenancyAgreementURL;
//             }
      
//              if (faceData) {
//               payload.faceData = JSON.stringify(faceData);
//             }
      
      
//             if (Object.keys(payload).length === 0) {
//               return toast.error("Error uploading files");
//             }
      
//             makeRequest(
//               JOBSEEKER_URL + `/updateJobSeeker/${loggedInUser?.currentUser?._id}`,
//               "PUT",
//               payload,
//               (data) => {
//                 refetchUser();
//                 toast.success("Files uploaded successfully");
//               },
//               (error) => {
//                 console.log(error || "Error updating files");
//                 toast.error("Error updating files");
//               },
//               () => {
//                 setImageChange(false);
//                 setLoadingImageUpload(false);
//               }
//             );
//           } catch (error) {
//             toast.error("Unknown error, please try again later");
//             setLoadingImageUpload(false);
//           }
//         };
//          const handleUpdate = async () => {
//           setLoadingUpdate(true);
//           makeRequest(
//             JOBSEEKER_URL + `/updateJobSeeker/${loggedInUser?.currentUser?._id}`,
//             "PUT",
//             profileInfo,
//             (data) => {
//               refetchUser();
//             },
//             (error) => {
//               console.log(error);
//             },
//             () => {
//               setLoadingUpdate(false);
//               setChangeListener(false);
//             }
//           );
//         };
      
      
//           const handleVerifyNIN = async () => {
//           if (!profileInfo.nin || !/^\d{11}$/.test(profileInfo.nin)) {
//             toast.error("Please enter a valid 11-digit NIN");
//             return;
//           }
      
//           setLoadingNINVerification(true);
//           try {
//             const response = await axios.post(
//               `${process.env.REACT_APP_API_URL}jobseeker/verify-nin`,
//               { nin: profileInfo.nin, userId },
//               {
//                 headers: { Authorization: `Bearer ${token}` },
//               }
//             );
      
//             setNINVerificationStatus({
//               status: 'success',
//               data: response.data.verifiedData,
//             });
//             dispatch(updateUser({
//               ...loggedInUser.currentUser,
//               nin: response.data.verifiedData.nin,
//               isNINVerified: true,
//               firstName: response.data.verifiedData.firstName || loggedInUser.currentUser.firstName,
//               lastName: response.data.verifiedData.lastName || loggedInUser.currentUser.lastName,
//               dateOfBirth: response.data.verifiedData.dateOfBirth || loggedInUser.currentUser.dateOfBirth,
//             }));
//             toast.success("NIN verified successfully");
//           } catch (error) {
//             setNINVerificationStatus({
//               status: 'error',
//               message: error.response?.data?.msg || "Error verifying NIN",
//             });
//             toast.error(error.response?.data?.msg || "Error verifying NIN");
//           } finally {
//             setLoadingNINVerification(false);
//           }
//         };
      
    
//   return (
//     <div>
//        <div className="bg-white rounded-lg shadow-sm p-6 mb-8">
//           <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
//             {/* Profile Picture Section */}
//             <div className="space-y-6">
//               <label>Your profile picture</label>
//                    <div className="relative flex items-center">
                 
//                 <img
//                   src={previewImage || userDetails?.avatar || DefaultProfile}
//                   alt="Profile"
//                   className="w-32 h-32 rounded-full object-cover border-4 border-gray-100 shadow-sm"
//                 />
//                 <button
//                   onClick={() => fileInputRef.current.click()}
//                   className="absolute bottom-0 left-0 p-2 bg-white rounded-full shadow-lg hover:bg-gray-50 transition-colors"
//                 >
//                   <FaCamera className="text-gray-600" />
//                 </button>
//                 <input
//                   ref={fileInputRef}
//                   type="file"
//                   name="avatar"
//                   onChange={(e) => handleAvatar(e, "avatar")}
//                   className="hidden"
//                 />
//                 {imageChange ? (
//                   <button
//                     onClick={handleUpdateImage}
//                     className="bg-green-400 ml-2 hover:bg-green-500 text-white p-[3px] rounded-sm"
//                   >
//                     {loadingImageUpload ? <Spinner /> : "Upload"}
//                   </button>
//                 ) : null}
//               </div>
//                  <label>Face Authentication</label>
//               <FaceAuth onFaceData={setFaceData} token={token} />
//               {/* Voters Card */}
//                    <label className="mt-3">Your Voters card</label>
//               <div className="relative flex items-center">
//                 <img
//                   src={votersCardPreview || userDetails?.votersCard || DefaultProfile}
//                   alt="Voter's Card"
//                   className="w-32 h-32 rounded-full object-cover border-4 border-gray-100 shadow-sm"
//                 />
//                 <button
//                   onClick={() => votersCardInputRef.current.click()}
//                   className="absolute bottom-0 left-0 p-2 bg-white rounded-full shadow-lg hover:bg-gray-50 transition-colors"
//                 >
//                   <FaCamera className="text-gray-600" />
//                 </button>
//                 <input
//                   ref={votersCardInputRef}
//                   type="file"
//                   name="votersCard"
//                   onChange={(e) => handleAvatar(e, "votersCard")}
//                   className="hidden"
//                 />
//               </div>

//               {/* Residential Card */}
//               <label className="mt-3">Your residential card</label>
//               <div className="relative flex items-center">
//                 <img
//                   src={residentialCardPreview || userDetails?.residentialCard || DefaultProfile}
//                   alt="Residential Card"
//                   className="w-32 h-32 rounded-full object-cover border-4 border-gray-100 shadow-sm"
//                 />
//                 <button
//                   onClick={() => residentialCardInputRef.current.click()}
//                   className="absolute bottom-0 left-0 p-2 bg-white rounded-full shadow-lg hover:bg-gray-50 transition-colors"
//                 >
//                   <FaCamera className="text-gray-600" />
//                 </button>
//                 <input
//                   ref={residentialCardInputRef}
//                   type="file"
//                   name="residentialCard"
//                   onChange={(e) => handleAvatar(e, "residentialCard")}
//                   className="hidden"
//                 />
//               </div>
//               {/* Scanning Evidence */}
//                  <label className="mt-3">Your scanning evidence</label>
//               <div className="relative flex items-center">
//                 <img
//                   src={scanningEvidencePreview || userDetails?.scanningEvidence || DefaultProfile}
//                   alt="Scanning Evidence"
//                   className="w-32 h-32 rounded-full object-cover border-4 border-gray-100 shadow-sm"
//                 />
//                 <button
//                   onClick={() => scanningEvidenceInputRef.current.click()}
//                   className="absolute bottom-0 left-0 p-2 bg-white rounded-full shadow-lg hover:bg-gray-50 transition-colors"
//                 >
//                   <FaCamera className="text-gray-600" />
//                 </button>
//                 <input
//                   ref={scanningEvidenceInputRef}
//                   type="file"
//                   name="scanningEvidence"
//                   onChange={(e) => handleAvatar(e, "scanningEvidence")}
//                   className="hidden"
//                 />
//               </div>
//               {/* Tenancy Agreement */}
//                  <label className="mt-3">Your tenancy agreement</label>
//               <div className="relative flex items-center">
//                 <img
//                   src={tenancyAgreementPreview || userDetails?.tenancyAgreement || DefaultProfile}
//                   alt="Tenancy Agreement"
//                   className="w-32 h-32 rounded-full object-cover border-4 border-gray-100 shadow-sm"
//                 />
//                 <button
//                   onClick={() => tenancyAgreementInputRef.current.click()}
//                   className="absolute bottom-0 left-0 p-2 bg-white rounded-full shadow-lg hover:bg-gray-50 transition-colors"
//                 >
//                   <FaCamera className="text-gray-600" />
//                 </button>
//                 <input
//                   ref={tenancyAgreementInputRef}
//                   type="file"
//                   name="tenancyAgreement"
//                   onChange={(e) => handleAvatar(e, "tenancyAgreement")}
//                   className="hidden"
//                 />
//               </div>
//               <div className="p-4 bg-gray-50 rounded-lg border border-gray-200">
//                 <h3 className="font-medium text-gray-900 mb-2">
//                   Primary Address
//                 </h3>
//                 <p className="text-gray-600">
//                   {loggedInUser?.currentUser?.address || "No address provided"}
//                 </p>
//               </div>

//                   {/* <div className="relative flex items-center">
//                 <img
//                   src={previewImage || userDetails?.avatar1 || DefaultProfile}
//                   alt="evidence of payment"
//                   className="w-32 h-32 rounded-full object-cover border-4 border-gray-100 shadow-sm"
//                 />
//                 <button
//                   onClick={() => fileInputRef.current.click()}
//                   className="absolute bottom-0 left-0 p-2 bg-white rounded-full shadow-lg hover:bg-gray-50 transition-colors"
//                 >
//                   <FaCamera className="text-gray-600" />
//                 </button>


                
//                 <input
//                   ref={fileInputRef}
//                   type="file"
//                   name="avatar1"
//                   onChange={handleAvatar}
//                   className="hidden"
//                 />
//                 {imageChange ? (
//                   <button
//                     onClick={handleUpdateImage}
//                     className="bg-green-400 ml-2 hover:bg-green-500 text-white p-[3px] rounded-sm"
//                   >
//                     {loadingImageUpload ? <Spinner /> : "Upload"}
//                   </button>
//                 ) : null}
//               </div> */}
//             </div>

//             {/* Personal Information */}
//             <div className="space-y-4">
//               <FormField
//                 label="First Name"
//                 name="firstName"
//                 type="text"
//                 value={profileInfo.firstName}
//                 placeholder={loggedInUser.currentUser.firstName}
//                 onChange={handleProfileChange}
//               />
//               <FormField
//                 label="Email"
//                 name="email"
//                 type="email"
//                 value={profileInfo.email}
//                 placeholder={loggedInUser.currentUser.email}
//                 onChange={handleProfileChange}
//               />
//               <FormField
//                 label="Date of Birth"
//                 name="dateOfBirth"
//                 type="date"
//                 placeholder={loggedInUser.currentUser.dateOfBirth}
//                 value={profileInfo.dateOfBirth}
//                 onChange={handleProfileChange}
//               />
//               <SelectField
//                 label="Gender"
//                 name="gender"
//                 placeholder={loggedInUser.currentUser.gender}
//                 value={profileInfo.gender}
//                 onChange={handleProfileChange}
//                 options={["male", "female"]}
//               />
//               <SelectField
//                 label="Job Decision"
//                 name="jobDecision"
//                 placeholder={loggedInUser.currentUser.jobDecision}
//                 value={profileInfo.jobDecision}
//                 onChange={handleProfileChange}
//                 options={["job-seeker", "job-changer"]}
//               />
           
//                  <SelectField
//                 label="Do you live alone"
//                 name="liveAlone"
//                 value={profileInfo.liveAlone}
//                 onChange={handleProfileChange}
//                 options={["Yes", "No"]}
//               />

//               {profileInfo.liveAlone === "No" && (
//                    <FormField
//                 label="who do you live with"
//                 name="whoDoYouLiveWith"
//                 type="text"
//                 value={profileInfo.whoDoYouLiveWith}
//                 onChange={handleProfileChange}

                
//               />
//               )}
               
           

                  
            
//                    <FormField
//                 label="how much is your rent"
//                 name="rentfee"
//                 type="text"
//                 placeholder={loggedInUser.currentUser.rentfee}
//                 value={profileInfo.rentfee}
//                 onChange={handleProfileChange}
//               />

//                        <FormField
//                 label="landlord or Agent Number"
//                 name="landlordNumber"
//                 type="text"
//                 value={profileInfo.landlordNumber}
//                 placeholder={loggedInUser.currentUser.landlordNumber}
//                 onChange={handleProfileChange}
//               />
//                        <FormField
//                 label="number of Rooms"
//                 name="numberOfRooms"
//                 type="text"
//                 value={profileInfo.numberOfRooms}
//                 placeholder={loggedInUser.currentUser.numberOfRooms}
//                 onChange={handleProfileChange}
//               />
//                        <FormField
//                 label="number of people living in the house"
//                 name="numberOfPeople"
//                 type="text"
//                 value={profileInfo.numberOfPeople}
//                     placeholder={loggedInUser.currentUser.numberOfPeople}
//                 onChange={handleProfileChange}
//               />

//                   <FormField
//                 label="tiktokHandle"
//                 name="tiktokHandle"
//                 type="text"
//                 value={profileInfo.tiktokHandle}
//                 placeholder={loggedInUser.currentUser.tiktokHandle}
//                 onChange={handleProfileChange}
//               />
//                  <FormField
//                 label="instagramHandle"
//                 name="instagramHandle"
//                 type="text"
//                 value={profileInfo.instagramHandle}
//                 placeholder={loggedInUser.currentUser.instagramHandle}
//                 onChange={handleProfileChange}
//               />
                

//                   <SelectField
//                  label="registered with e-verify?"
//                 name="registeredEverify"
//                 value={profileInfo.registeredEverify}
//                 onChange={handleProfileChange}
//                 options={["No", "Yes", ]}
//               />

            
//                    <FormField
//                 label="next of kin Name"
//                 name="nextOfKin"
//                 type="text"
//                 value={profileInfo.nextOfKin}
//                 placeholder={loggedInUser.currentUser.nextOfKin}
//                 onChange={handleProfileChange}
//               />
//                    <SelectField
//                 label="marital status"
//                 name="maritalStatus"
//                 value={profileInfo.maritalStatus}
//                 onChange={handleProfileChange}
//                 options={["single", "married", "divorce", "widow", "widower", "separated"]}
//               />


//               {profileInfo.nextOfKin !=='' && (
//                 <>
//                      <FormField
//                 label="next of kin phoneNumber"
//                 name="nextOfKinNumber"
//                 type="number"
//                 value={profileInfo.nextOfKinNumber}
//                 placeholder={loggedInUser.currentUser.nextOfKinNumber}
//                 onChange={handleProfileChange}
//               />

//                         <FormField
//                 label="next of kin address"
//                 name="nextOfKinAddress"
//                 type="text"
//                 value={profileInfo.nextOfKinAddress}
//                 placeholder={loggedInUser.currentUser.nextOfKinAddress}
//                 onChange={handleProfileChange}
//               />

//                      <FormField
//                 label="next of kin relationship"
//                 name="nextOfKinRelationship"
//                 type="text"
//                 value={profileInfo.nextOfKinRelationship}
//                 placeholder={loggedInUser.currentUser.nextOfKinRelationship}
//                 onChange={handleProfileChange}
//               />
//                      {/* <FormField
//                 label="Tax Identification Number"
//                 name="TIN"
//                 type="text"
//                 value={profileInfo.TIN}
//                 placeholder={loggedInUser.currentUser.TIN}
//                 onChange={handleProfileChange}
//               /> */}


//                 </>
//               )  }
                

//             </div>
            
         
            
               
       
        

//             {/* Additional Information */}
//             <div className="space-y-4">
//               <FormField
//                 label="Last Name"
//                 name="lastName"
//                 type="text"
//                 value={profileInfo.lastName}
//                 placeholder={loggedInUser.currentUser.lastName}
//                 onChange={handleProfileChange}
//               />
//               <FormField
//                 label="Phone Number"
//                 name="phoneNumber"
//                 type="tel"
//                 value={profileInfo.phoneNumber}
//                 placeholder={loggedInUser.currentUser.phoneNumber}
//                 onChange={handleProfileChange}
//               />
//               <FormField
//                 label="Whatsapp Number"
//                 name="whatsappNumber"
//                 type="tel"
//                 value={profileInfo.whatsappNumber}
//                 placeholder={loggedInUser.currentUser.whatsappNumber}
//                 onChange={handleProfileChange}
//               />
//               <FormField
//                 label="Job decision salary"
//                 name="jobDecisionSalary"
//                 type="text"
//                 value={profileInfo.jobDecisionSalary}
//                 placeholder={loggedInUser.currentUser.jobDecisionSalary}
//                 onChange={handleProfileChange}
//               />
//               <SelectField
//                 label="Race"
//                 name="race"
//                 value={profileInfo.race}
//                 onChange={handleProfileChange}
//                 options={race}
//               />
//               <SelectField
//                 label="Disability"
//                 name="disability"
//                 value={profileInfo.disability}
//                 onChange={handleProfileChange}
//                 options={["No", "Yes"]}
//               />
//               <SelectField
//                 label="have any criminal record?"
//                 name="criminalRecord"
//                 value={profileInfo.criminalRecord}
//                 onChange={handleProfileChange}
//                 options={["No", "Yes"]}
//               />
//                   <SelectField
//                 label="highest educational level?"
//                 name="educationLevel"
//                 value={profileInfo.educationLevel}
//                 onChange={handleProfileChange}
//                 options={["PHD", "masters", "graduate", "undergraduate", "SSCE", "others"]}
//               />
              


//               {profileInfo.criminalRecord === "Yes" && (
//                 <>
//                    <FormField
//                 label="when was it"
//                 name="when"
//                 type="date"
//                 value={profileInfo.when}
//                 placeholder={loggedInUser.currentUser.when}
//                 onChange={handleProfileChange}
//               />
//                    <FormField
//                 label="where was it"
//                 name="where"
//                 type="text"
//                 value={profileInfo.where}
//                 placeholder={loggedInUser.currentUser.where}
//                 onChange={handleProfileChange}
//               />
//                    <FormField
//                 label="what was the incident"
//                 name="incident"
//                 type="text"
//                 value={profileInfo.incident}
//                 placeholder={loggedInUser.currentUser.incident}
//                 onChange={handleProfileChange}
//               />
//                    <FormField
//                 label="how many kilometer distance will you like  to work from  your house"
//                 name="km"
//                 type="text"
//                 value={profileInfo.km}
//                 placeholder={loggedInUser.currentUser.km}
//                 onChange={handleProfileChange}
//               />
//                    <FormField
//                 label="can you work outside your state of residence"
//                 name="workOutside"
//                 type="text"
//                 value={profileInfo.workOutside}
//                 placeholder={loggedInUser.currentUser.workOutside}
//                 onChange={handleProfileChange}
//               />
//                 <SelectField
//                 label="nature of offence?"
//                 name="natureOfOffence"
//                 value={profileInfo.natureOfOffence}
//                 onChange={handleProfileChange}
//                 options={["murder", "rape", "stealing", "others"]}
//               />
            
                

//                 </>
//               )}
//               <SelectField
//                 label="any child?"
//                 name="anyChild"
//                 value={profileInfo.anyChild}
//                 onChange={handleProfileChange}
//                 options={["No", "Yes",]}
//               />

//               {profileInfo.anyChild === "Yes" && (
//                 <>
//                        <FormField
//                 label="how many children"
//                 name="numberOfChildren"
//                 type="text"
//                 value={profileInfo.numberOfChildren}
//                 placeholder={loggedInUser.currentUser.numberOfChildren}
//                 onChange={handleProfileChange}
//               />
//                 </>
//               )}

//                 <SelectField
//                 label="any vocational skill?"
//                 name="handworkSkill"
//                 value={profileInfo.handworkSkill}
//                 onChange={handleProfileChange}
//                 options={["No", "Yes",]}
//               />


//               {profileInfo.handworkSkill === "Yes" && (
//                         <FormField
//                 label="please specify"
//                 name="specifyHandworkSkill"
//                 type="text"
//                 value={profileInfo.specifyHandworkSkill}
//                 placeholder={loggedInUser.currentUser.specifyHandworkSkill}
//                 onChange={handleProfileChange}
//               />
//               )
//               }

//                <SelectField
//                 label="what kind of work do you prefer"
//                 name="workingMode"
//                 value={profileInfo.workingMode}
//                 onChange={handleProfileChange}
//                 options={["work with accommodation and open for relocation", 
//                 "work without accommodation and open for relocation",
//                 "work with accommodation and not open for relocation",
//                 "work without accommodation and not open for relocation"
//                 ]}

                
//               />

//                    <FormField
//                 label="what is the minimum salary you expect"
//                 name="minimumSalary"
//                 type="text"
//                 value={profileInfo.minimumSalary}
//                 placeholder={loggedInUser.currentUser.minimumSalary}
//                 onChange={handleProfileChange}
//               />

//                  <FormField
//                 label="what is the least salary you expect"
//                 name="leastSalary"
//                 type="text"
//                 value={profileInfo.leastSalary}
//                 placeholder={loggedInUser.currentUser.leastSalary}
//                 onChange={handleProfileChange}
//               />
//                  <FormField
//                 label="facebookHandle"
//                 name="facebookHandle"
//                 type="text"
//                 value={profileInfo.facebookHandle}
//                 placeholder={loggedInUser.currentUser.facebookHandle}
//                 onChange={handleProfileChange}
//               />
//                  {/* <FormField
//                 label="NIN"
//                 name="nin"
//                 type="text"
//                 value={profileInfo.nin}
//                 placeholder={loggedInUser.currentUser.nin}
//                 onChange={handleProfileChange}
//               /> */}

//                   <div className="flex items-end gap-2">
//                 {/* <FormField
//                   label="NIN"
//                   name="nin"
//                   type="text"
//                   value={profileInfo.nin}
//                   placeholder={loggedInUser.currentUser.nin || "Enter your NIN"}
//                   onChange={handleProfileChange}
//                 /> */}
//                 {/* <button
//                   onClick={handleVerifyNIN}
//                   disabled={loadingNINVerification || userDetails?.isNINVerified}
//                   className={`p-2 rounded-md text-white ${
//                     loadingNINVerification || userDetails?.isNINVerified
//                       ? 'bg-gray-400 cursor-not-allowed'
//                       : 'bg-blue-500 hover:bg-blue-600'
//                   }`}
//                 >
//                   {loadingNINVerification ? <Spinner /> : userDetails?.isNINVerified ? 'Verified' : 'Verify NIN'}
//                 </button> */}
//               </div>
//               {ninVerificationStatus?.status === 'success' && (
//                 <div className="mt-2 p-4 bg-green-100 rounded">
//                   <p><strong>Verified Name:</strong> {ninVerificationStatus.data.firstName} {ninVerificationStatus.data.lastName}</p>
//                   <p><strong>Date of Birth:</strong> {ninVerificationStatus.data.dateOfBirth}</p>
//                   <p><strong>NIN:</strong> ****</p>
//                 </div>
//               )}
//               {ninVerificationStatus?.status === 'error' && (
//                 <p className="mt-2 text-red-500">{ninVerificationStatus.message}</p>
//               )}
              

//                    <FormField
//                 label="Bank Name"
//                 name="bankName"
//                 type="text"
//                 value={profileInfo.bankName}
//                 placeholder={loggedInUser.currentUser.bankName}
//                 onChange={handleProfileChange}
//               />

//               {profileInfo.bankName !== '' && (
//                 <>
//                    <FormField
//                 label="Bank Acct Name"
//                 name="bankAcctName"
//                 type="text"
//                 value={profileInfo.bankAcctName}
//                 placeholder={loggedInUser.currentUser.bankAcctName}
//                 onChange={handleProfileChange}
//               />
//                    <FormField
//                 label="Bank Acct Num"
//                 name="bankAcctNum"
//                 type="text"
//                 value={profileInfo.bankAcctNum}
//                 placeholder={loggedInUser.currentUser.bankAcctNum}
//                 onChange={handleProfileChange}
//               />
//                 </>
//               )}

           
             

//             </div>
//           </div>
//           <div className='ml-80 flex space-x-3 wrap-4'>
//                    {changeListener && (
//             <div className="mt-6 text-center">
//               <button
//                 onClick={handleUpdate}
//                 disabled={loadingUpdate}
//                 className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors disabled:opacity-50"
//               >
//                 {loadingUpdate ? <LoadSpinner /> : "Save Changes"}
//               </button>
//             </div>
//           )}
//   {changeListener && (
//             <div className="mt-6 text-center">
//               <Link to='/profile/:id?tab=my-details'
               
            
//                 className="px-6 py-3 bg-orange-600 text-white rounded-md hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors disabled:opacity-50"
//               >
//                 fill in your other details to create a CV
          
//               </Link>

             
//             </div>
//           )}
//           </div>
        
//         </div>

         
      
//     </div>
//   )
// }



// // Helper Components
// const FormField = ({ label, name, type, value, placeholder, onChange }) => (
//   <div className="space-y-1">
//     <label htmlFor={name} className="block text-sm font-medium text-gray-700">
//       {label}
//     </label>
//     <input
//       type={type}
//       name={name}
//       id={name}
//       value={value || ""}
//       onChange={onChange}
//       placeholder={placeholder}
//       className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
//     />
//   </div>
// );

// const SelectField = ({ label, name, value, onChange, options }) => (
//   <div className="space-y-1">
//     <label htmlFor={name} className="block text-sm font-medium text-gray-700">
//       {label}
//     </label>
//     <select
//       name={name}
//       id={name}
//       value={value || ""}
//       onChange={onChange}
//       className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
//     >
//       <option value="">Select {label}</option>
//       {options?.map((option) => (
//         <option key={option} value={option}>
//           {option}
//         </option>
//       ))}
//     </select>
//   </div>
// );


// export default Profile






















import React, { useState, useRef, useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { BarChart, Bar, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';
import { useFetchData } from "../../../../hooks/useFtechData";
import { JOBSEEKER_URL } from "../../../../resources/resource";
import { useMakeRequest } from '../../../../hooks/useMakeRequest';
import { toast } from 'react-toastify';
import { uploadToCloudinary } from '../../../../Utils/cloudinaryUpload';
import { updateUser } from '../../../../redux/users/userSlice'
import FaceAuth from '../../FaceAuth';
import LoadSpinner from '../../../../component/Modals/LoadSpinner';
import { FaCamera } from "react-icons/fa6";
import DefaultProfile from "../../../../assets/Images/employee.png"
import axios from 'axios';
import { Spinner } from 'flowbite-react';
import { race } from '../../data';
import { Link } from 'react-router-dom';

const Profile = () => {
  const dispatch = useDispatch();
  const { currentUser, token } = useSelector((state) => state.user);
  const loggedInUser = useSelector((state) => state.user);

  const fileInputRef = useRef();
  const makeRequest = useMakeRequest();
  const votersCardInputRef = useRef();
  const residentialCardInputRef = useRef();
  const scanningEvidenceInputRef = useRef();
  const tenancyAgreementInputRef = useRef();

  const { data: userDetails, refetch: refetchUser } = useFetchData(
    JOBSEEKER_URL + `/getAjobSeeker/${loggedInUser?.currentUser?._id}`
  );

  const [showForm, setShowForm] = useState(false);
  const [changeListener, setChangeListener] = useState(false);
  const [loadingUpdate, setLoadingUpdate] = useState(false);
  const [loadingImageUpload, setLoadingImageUpload] = useState(false);
  const [loadingNINVerification, setLoadingNINVerification] = useState(false);
  const [ninVerificationStatus, setNINVerificationStatus] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [votersCardPreview, setVotersCardPreview] = useState(null);
  const [residentialCardPreview, setResidentialCardPreview] = useState(null);
  const [scanningEvidencePreview, setScanningEvidencePreview] = useState(null);
  const [tenancyAgreementPreview, setTenancyAgreementPreview] = useState(null);
  const [imageChange, setImageChange] = useState(false);
  const [votersCard, setVotersCard] = useState(null);
  const [residentialCard, setResidentialCard] = useState(null);
  const [scanningEvidence, setScanningEvidence] = useState(null);
  const [tenancyAgreement, setTenancyAgreement] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  const [faceData, setFaceData] = useState(null);
  const [profileInfo, setProfileInfo] = useState({
    jobSeekerId: loggedInUser?.currentUser?._id,
    nin: '',
  });

  const userId = localStorage.getItem('userId');

  // Seed profileInfo from the fetched user record once it loads, so the
  // form starts with the user's actual saved values instead of blanks —
  // otherwise saving without touching every field would overwrite data
  // with undefined.
  useEffect(() => {
    if (userDetails) {
      setProfileInfo((prev) => ({
        ...userDetails,
        jobSeekerId: loggedInUser?.currentUser?._id,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userDetails]);

  const handleProfileChange = (e) => {
    setProfileInfo({
      ...profileInfo,
      [e.target.name]: e.target.value,
      jobSeekerId: loggedInUser.currentUser._id,
    });

    setChangeListener(true);
  };

  const handleAvatar = async (e, fileType) => {
    const file = e.target.files[0];
    if (!file) return;

    switch (fileType) {
      case "avatar":
        setImageFile(file);
        setPreviewImage(URL.createObjectURL(file));
        break;
      case "votersCard":
        setVotersCard(file);
        setVotersCardPreview(URL.createObjectURL(file));
        break;
      case "residentialCard":
        setResidentialCard(file);
        setResidentialCardPreview(URL.createObjectURL(file));
        break;
      case "scanningEvidence":
        setScanningEvidence(file);
        setScanningEvidencePreview(URL.createObjectURL(file));
        break;
      case "tenancyAgreement":
        setTenancyAgreement(file);
        setTenancyAgreementPreview(URL.createObjectURL(file));
        break;
      default:
        break;
    }
    setImageChange(true);
  };

  const handleUpdateImage = async () => {
    if (!imageFile && !votersCard && !residentialCard && !scanningEvidence && !tenancyAgreement && !faceData) {
      return toast.error('Kindly select at least one file or complete face authentication to upload');
    }
    setLoadingImageUpload(true);
    try {
      const payload = {};
      if (imageFile) {
        const imageURL = await uploadToCloudinary(imageFile);
        if (imageURL) payload.avatar = imageURL;
      }
      if (votersCard) {
        const votersCardURL = await uploadToCloudinary(votersCard);
        if (votersCardURL) payload.votersCard = votersCardURL;
      }
      if (residentialCard) {
        const residentialCardURL = await uploadToCloudinary(residentialCard);
        if (residentialCardURL) payload.residentialCard = residentialCardURL;
      }
      if (scanningEvidence) {
        const scanningEvidenceURL = await uploadToCloudinary(scanningEvidence);
        if (scanningEvidenceURL) payload.scanningEvidence = scanningEvidenceURL;
      }
      if (tenancyAgreement) {
        const tenancyAgreementURL = await uploadToCloudinary(tenancyAgreement);
        if (tenancyAgreementURL) payload.tenancyAgreement = tenancyAgreementURL;
      }

      if (faceData) {
        payload.faceData = JSON.stringify(faceData);
      }

      if (Object.keys(payload).length === 0) {
        return toast.error("Error uploading files");
      }

      makeRequest(
        JOBSEEKER_URL + `/updateJobSeeker/${loggedInUser?.currentUser?._id}`,
        "PUT",
        payload,
        (data) => {
          refetchUser();
          toast.success("Files uploaded successfully");
        },
        (error) => {
          console.log(error || "Error updating files");
          toast.error("Error updating files");
        },
        () => {
          setImageChange(false);
          setLoadingImageUpload(false);
        }
      );
    } catch (error) {
      toast.error("Unknown error, please try again later");
      setLoadingImageUpload(false);
    }
  };

  const handleUpdate = async () => {
    setLoadingUpdate(true);
    makeRequest(
      JOBSEEKER_URL + `/updateJobSeeker/${loggedInUser?.currentUser?._id}`,
      "PUT",
      profileInfo,
      (data) => {
        refetchUser();
      },
      (error) => {
        console.log(error);
      },
      () => {
        setLoadingUpdate(false);
        setChangeListener(false);
      }
    );
  };

  const handleVerifyNIN = async () => {
    if (!profileInfo.nin || !/^\d{11}$/.test(profileInfo.nin)) {
      toast.error("Please enter a valid 11-digit NIN");
      return;
    }

    setLoadingNINVerification(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}jobseeker/verify-nin`,
        { nin: profileInfo.nin, userId },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setNINVerificationStatus({
        status: 'success',
        data: response.data.verifiedData,
      });
      dispatch(updateUser({
        ...loggedInUser.currentUser,
        nin: response.data.verifiedData.nin,
        isNINVerified: true,
        firstName: response.data.verifiedData.firstName || loggedInUser.currentUser.firstName,
        lastName: response.data.verifiedData.lastName || loggedInUser.currentUser.lastName,
        dateOfBirth: response.data.verifiedData.dateOfBirth || loggedInUser.currentUser.dateOfBirth,
      }));
      toast.success("NIN verified successfully");
    } catch (error) {
      setNINVerificationStatus({
        status: 'error',
        message: error.response?.data?.msg || "Error verifying NIN",
      });
      toast.error(error.response?.data?.msg || "Error verifying NIN");
    } finally {
      setLoadingNINVerification(false);
    }
  };

  return (
    <div>
      <div className="bg-white rounded-lg shadow-sm p-6 mb-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Profile Picture Section */}
          <div className="space-y-6">
            <label>Your profile picture</label>
            <div className="relative flex items-center">
              <img
                src={previewImage || userDetails?.avatar || DefaultProfile}
                alt="Profile"
                className="w-32 h-32 rounded-full object-cover border-4 border-gray-100 shadow-sm"
              />
              <button
                onClick={() => fileInputRef.current.click()}
                className="absolute bottom-0 left-0 p-2 bg-white rounded-full shadow-lg hover:bg-gray-50 transition-colors"
              >
                <FaCamera className="text-gray-600" />
              </button>
              <input
                ref={fileInputRef}
                type="file"
                name="avatar"
                onChange={(e) => handleAvatar(e, "avatar")}
                className="hidden"
              />
              {imageChange ? (
                <button
                  onClick={handleUpdateImage}
                  className="bg-green-400 ml-2 hover:bg-green-500 text-white p-[3px] rounded-sm"
                >
                  {loadingImageUpload ? <Spinner /> : "Upload"}
                </button>
              ) : null}
            </div>

            {/* <label>Face Authentication</label>
            <FaceAuth onFaceData={setFaceData} token={token} /> */}

            {/* Voters Card */}
            <label className="mt-3">Your Voters card</label>
            <div className="relative flex items-center">
              <img
                src={votersCardPreview || userDetails?.votersCard || DefaultProfile}
                alt="Voter's Card"
                className="w-32 h-32 rounded-full object-cover border-4 border-gray-100 shadow-sm"
              />
              <button
                onClick={() => votersCardInputRef.current.click()}
                className="absolute bottom-0 left-0 p-2 bg-white rounded-full shadow-lg hover:bg-gray-50 transition-colors"
              >
                <FaCamera className="text-gray-600" />
              </button>
              <input
                ref={votersCardInputRef}
                type="file"
                name="votersCard"
                onChange={(e) => handleAvatar(e, "votersCard")}
                className="hidden"
              />
            </div>

            {/* Residential Card */}
            <label className="mt-3">Your residential card</label>
            <div className="relative flex items-center">
              <img
                src={residentialCardPreview || userDetails?.residentialCard || DefaultProfile}
                alt="Residential Card"
                className="w-32 h-32 rounded-full object-cover border-4 border-gray-100 shadow-sm"
              />
              <button
                onClick={() => residentialCardInputRef.current.click()}
                className="absolute bottom-0 left-0 p-2 bg-white rounded-full shadow-lg hover:bg-gray-50 transition-colors"
              >
                <FaCamera className="text-gray-600" />
              </button>
              <input
                ref={residentialCardInputRef}
                type="file"
                name="residentialCard"
                onChange={(e) => handleAvatar(e, "residentialCard")}
                className="hidden"
              />
            </div>

            {/* Scanning Evidence */}
            <label className="mt-3">Your scanning evidence</label>
            <div className="relative flex items-center">
              <img
                src={scanningEvidencePreview || userDetails?.scanningEvidence || DefaultProfile}
                alt="Scanning Evidence"
                className="w-32 h-32 rounded-full object-cover border-4 border-gray-100 shadow-sm"
              />
              <button
                onClick={() => scanningEvidenceInputRef.current.click()}
                className="absolute bottom-0 left-0 p-2 bg-white rounded-full shadow-lg hover:bg-gray-50 transition-colors"
              >
                <FaCamera className="text-gray-600" />
              </button>
              <input
                ref={scanningEvidenceInputRef}
                type="file"
                name="scanningEvidence"
                onChange={(e) => handleAvatar(e, "scanningEvidence")}
                className="hidden"
              />
            </div>

            {/* Tenancy Agreement */}
            <label className="mt-3">Your tenancy agreement</label>
            <div className="relative flex items-center">
              <img
                src={tenancyAgreementPreview || userDetails?.tenancyAgreement || DefaultProfile}
                alt="Tenancy Agreement"
                className="w-32 h-32 rounded-full object-cover border-4 border-gray-100 shadow-sm"
              />
              <button
                onClick={() => tenancyAgreementInputRef.current.click()}
                className="absolute bottom-0 left-0 p-2 bg-white rounded-full shadow-lg hover:bg-gray-50 transition-colors"
              >
                <FaCamera className="text-gray-600" />
              </button>
              <input
                ref={tenancyAgreementInputRef}
                type="file"
                name="tenancyAgreement"
                onChange={(e) => handleAvatar(e, "tenancyAgreement")}
                className="hidden"
              />
            </div>

            <div className="p-4 bg-gray-50 rounded-lg border border-gray-200">
              <h3 className="font-medium text-gray-900 mb-2">
                Primary Address
              </h3>
              <p className="text-gray-600">
                {loggedInUser?.currentUser?.address || "No address provided"}
              </p>
            </div>
          </div>

          {/* Personal Information */}
          <div className="space-y-4">
            <FormField
              label="First Name"
              name="firstName"
              type="text"
              value={profileInfo.firstName}
              placeholder={loggedInUser.currentUser.firstName}
              onChange={handleProfileChange}
            />
            <FormField
              label="Email"
              name="email"
              type="email"
              value={profileInfo.email}
              placeholder={loggedInUser.currentUser.email}
              onChange={handleProfileChange}
            />
            <FormField
              label="Date of Birth"
              name="dateOfBirth"
              type="date"
              placeholder={loggedInUser.currentUser.dateOfBirth}
              value={profileInfo.dateOfBirth}
              onChange={handleProfileChange}
            />
            <SelectField
              label="Gender"
              name="gender"
              placeholder={loggedInUser.currentUser.gender}
              value={profileInfo.gender}
              onChange={handleProfileChange}
              options={["male", "female"]}
            />
            <SelectField
              label="Job Decision"
              name="jobDecision"
              placeholder={loggedInUser.currentUser.jobDecision}
              value={profileInfo.jobDecision}
              onChange={handleProfileChange}
              options={["job-seeker", "job-changer"]}
            />

            <SelectField
              label="Do you live alone"
              name="liveAlone"
              value={profileInfo.liveAlone}
              onChange={handleProfileChange}
              options={["Yes", "No"]}
            />

            {profileInfo.liveAlone === "No" && (
              <FormField
                label="who do you live with"
                name="whoDoYouLiveWith"
                type="text"
                value={profileInfo.whoDoYouLiveWith}
                onChange={handleProfileChange}
              />
            )}

            <FormField
              label="how much is your rent"
              name="rentfee"
              type="text"
              placeholder={loggedInUser.currentUser.rentfee}
              value={profileInfo.rentfee}
              onChange={handleProfileChange}
            />

            <FormField
              label="landlord or Agent Number"
              name="landlordNumber"
              type="text"
              value={profileInfo.landlordNumber}
              placeholder={loggedInUser.currentUser.landlordNumber}
              onChange={handleProfileChange}
            />
            <FormField
              label="number of Rooms"
              name="numberOfRooms"
              type="text"
              value={profileInfo.numberOfRooms}
              placeholder={loggedInUser.currentUser.numberOfRooms}
              onChange={handleProfileChange}
            />
            <FormField
              label="number of people living in the house"
              name="numberOfPeople"
              type="text"
              value={profileInfo.numberOfPeople}
              placeholder={loggedInUser.currentUser.numberOfPeople}
              onChange={handleProfileChange}
            />

            <FormField
              label="tiktokHandle"
              name="tiktokHandle"
              type="text"
              value={profileInfo.tiktokHandle}
              placeholder={loggedInUser.currentUser.tiktokHandle}
              onChange={handleProfileChange}
            />
            <FormField
              label="instagramHandle"
              name="instagramHandle"
              type="text"
              value={profileInfo.instagramHandle}
              placeholder={loggedInUser.currentUser.instagramHandle}
              onChange={handleProfileChange}
            />

            <SelectField
              label="registered with e-verify?"
              name="registeredEverify"
              value={profileInfo.registeredEverify}
              onChange={handleProfileChange}
              options={["No", "Yes"]}
            />

            <FormField
              label="next of kin Name"
              name="nextOfKin"
              type="text"
              value={profileInfo.nextOfKin}
              placeholder={loggedInUser.currentUser.nextOfKin}
              onChange={handleProfileChange}
            />
            <SelectField
              label="marital status"
              name="maritalStatus"
              value={profileInfo.maritalStatus}
              onChange={handleProfileChange}
              options={["single", "married", "divorce", "widow", "widower", "separated"]}
            />

            {profileInfo.nextOfKin !== '' && (
              <>
                <FormField
                  label="next of kin phoneNumber"
                  name="nextOfKinNumber"
                  type="number"
                  value={profileInfo.nextOfKinNumber}
                  placeholder={loggedInUser.currentUser.nextOfKinNumber}
                  onChange={handleProfileChange}
                />

                <FormField
                  label="next of kin address"
                  name="nextOfKinAddress"
                  type="text"
                  value={profileInfo.nextOfKinAddress}
                  placeholder={loggedInUser.currentUser.nextOfKinAddress}
                  onChange={handleProfileChange}
                />

                <FormField
                  label="next of kin relationship"
                  name="nextOfKinRelationship"
                  type="text"
                  value={profileInfo.nextOfKinRelationship}
                  placeholder={loggedInUser.currentUser.nextOfKinRelationship}
                  onChange={handleProfileChange}
                />
              </>
            )}
          </div>

          {/* Additional Information */}
          <div className="space-y-4">
            <FormField
              label="Last Name"
              name="lastName"
              type="text"
              value={profileInfo.lastName}
              placeholder={loggedInUser.currentUser.lastName}
              onChange={handleProfileChange}
            />
            <FormField
              label="Phone Number"
              name="phoneNumber"
              type="tel"
              value={profileInfo.phoneNumber}
              placeholder={loggedInUser.currentUser.phoneNumber}
              onChange={handleProfileChange}
            />
            <FormField
              label="Whatsapp Number"
              name="whatsappNumber"
              type="tel"
              value={profileInfo.whatsappNumber}
              placeholder={loggedInUser.currentUser.whatsappNumber}
              onChange={handleProfileChange}
            />
            <FormField
              label="Job decision salary"
              name="jobDecisionSalary"
              type="text"
              value={profileInfo.jobDecisionSalary}
              placeholder={loggedInUser.currentUser.jobDecisionSalary}
              onChange={handleProfileChange}
            />
            <SelectField
              label="Race"
              name="race"
              value={profileInfo.race}
              onChange={handleProfileChange}
              options={race}
            />
            <SelectField
              label="Disability"
              name="disability"
              value={profileInfo.disability}
              onChange={handleProfileChange}
              options={["No", "Yes"]}
            />
            <SelectField
              label="have any criminal record?"
              name="criminalRecord"
              value={profileInfo.criminalRecord}
              onChange={handleProfileChange}
              options={["No", "Yes"]}
            />
            <SelectField
              label="highest educational level?"
              name="educationLevel"
              value={profileInfo.educationLevel}
              onChange={handleProfileChange}
              options={["PHD", "masters", "graduate", "undergraduate", "SSCE", "others"]}
            />

            {profileInfo.criminalRecord === "Yes" && (
              <>
                <FormField
                  label="when was it"
                  name="when"
                  type="date"
                  value={profileInfo.when}
                  placeholder={loggedInUser.currentUser.when}
                  onChange={handleProfileChange}
                />
                <FormField
                  label="where was it"
                  name="where"
                  type="text"
                  value={profileInfo.where}
                  placeholder={loggedInUser.currentUser.where}
                  onChange={handleProfileChange}
                />
                <FormField
                  label="what was the incident"
                  name="incident"
                  type="text"
                  value={profileInfo.incident}
                  placeholder={loggedInUser.currentUser.incident}
                  onChange={handleProfileChange}
                />
                <FormField
                  label="how many kilometer distance will you like  to work from  your house"
                  name="km"
                  type="text"
                  value={profileInfo.km}
                  placeholder={loggedInUser.currentUser.km}
                  onChange={handleProfileChange}
                />
                <FormField
                  label="can you work outside your state of residence"
                  name="workOutside"
                  type="text"
                  value={profileInfo.workOutside}
                  placeholder={loggedInUser.currentUser.workOutside}
                  onChange={handleProfileChange}
                />
                <SelectField
                  label="nature of offence?"
                  name="natureOfOffence"
                  value={profileInfo.natureOfOffence}
                  onChange={handleProfileChange}
                  options={["murder", "rape", "stealing", "others"]}
                />
              </>
            )}

            <SelectField
              label="any child?"
              name="anyChild"
              value={profileInfo.anyChild}
              onChange={handleProfileChange}
              options={["No", "Yes"]}
            />

            {profileInfo.anyChild === "Yes" && (
              <FormField
                label="how many children"
                name="numberOfChildren"
                type="text"
                value={profileInfo.numberOfChildren}
                placeholder={loggedInUser.currentUser.numberOfChildren}
                onChange={handleProfileChange}
              />
            )}

            <SelectField
              label="any vocational skill?"
              name="handworkSkill"
              value={profileInfo.handworkSkill}
              onChange={handleProfileChange}
              options={["No", "Yes"]}
            />

            {profileInfo.handworkSkill === "Yes" && (
              <FormField
                label="please specify"
                name="specifyHandworkSkill"
                type="text"
                value={profileInfo.specifyHandworkSkill}
                placeholder={loggedInUser.currentUser.specifyHandworkSkill}
                onChange={handleProfileChange}
              />
            )}

            <SelectField
              label="what kind of work do you prefer"
              name="workingMode"
              value={profileInfo.workingMode}
              onChange={handleProfileChange}
              options={[
                "work with accommodation and open for relocation",
                "work without accommodation and open for relocation",
                "work with accommodation and not open for relocation",
                "work without accommodation and not open for relocation",
              ]}
            />

            <FormField
              label="what is the minimum salary you expect"
              name="minimumSalary"
              type="text"
              value={profileInfo.minimumSalary}
              placeholder={loggedInUser.currentUser.minimumSalary}
              onChange={handleProfileChange}
            />

            <FormField
              label="what is the least salary you expect"
              name="leastSalary"
              type="text"
              value={profileInfo.leastSalary}
              placeholder={loggedInUser.currentUser.leastSalary}
              onChange={handleProfileChange}
            />
            <FormField
              label="facebookHandle"
              name="facebookHandle"
              type="text"
              value={profileInfo.facebookHandle}
              placeholder={loggedInUser.currentUser.facebookHandle}
              onChange={handleProfileChange}
            />

            {ninVerificationStatus?.status === 'success' && (
              <div className="mt-2 p-4 bg-green-100 rounded">
                <p><strong>Verified Name:</strong> {ninVerificationStatus.data.firstName} {ninVerificationStatus.data.lastName}</p>
                <p><strong>Date of Birth:</strong> {ninVerificationStatus.data.dateOfBirth}</p>
                <p><strong>NIN:</strong> ****</p>
              </div>
            )}
            {ninVerificationStatus?.status === 'error' && (
              <p className="mt-2 text-red-500">{ninVerificationStatus.message}</p>
            )}

            <FormField
              label="Bank Name"
              name="bankName"
              type="text"
              value={profileInfo.bankName}
              placeholder={loggedInUser.currentUser.bankName}
              onChange={handleProfileChange}
            />

            {profileInfo.bankName !== '' && (
              <>
                <FormField
                  label="Bank Acct Name"
                  name="bankAcctName"
                  type="text"
                  value={profileInfo.bankAcctName}
                  placeholder={loggedInUser.currentUser.bankAcctName}
                  onChange={handleProfileChange}
                />
                <FormField
                  label="Bank Acct Num"
                  name="bankAcctNum"
                  type="text"
                  value={profileInfo.bankAcctNum}
                  placeholder={loggedInUser.currentUser.bankAcctNum}
                  onChange={handleProfileChange}
                />
              </>
            )}
          </div>
        </div>

        <div className="flex flex-wrap items-center justify-end gap-3 mt-6">
          {changeListener && (
            <button
              onClick={handleUpdate}
              disabled={loadingUpdate}
              className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors disabled:opacity-50"
            >
              {loadingUpdate ? <LoadSpinner /> : "Save Changes"}
            </button>
          )}
          {changeListener && (
            <Link
              to='/profile/:id?tab=my-details'
              className="px-6 py-3 bg-orange-600 text-white rounded-md hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors disabled:opacity-50"
            >
              fill in your other details to create a CV
            </Link>
          )}
        </div>
      </div>
    </div>
  )
}

// Helper Components
const FormField = ({ label, name, type, value, placeholder, onChange }) => (
  <div className="space-y-1">
    <label htmlFor={name} className="block text-sm font-medium text-gray-700">
      {label}
    </label>
    <input
      type={type}
      name={name}
      id={name}
      value={value || ""}
      onChange={onChange}
      placeholder={placeholder}
      className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
    />
  </div>
);

const SelectField = ({ label, name, value, onChange, options }) => (
  <div className="space-y-1">
    <label htmlFor={name} className="block text-sm font-medium text-gray-700">
      {label}
    </label>
    <select
      name={name}
      id={name}
      value={value || ""}
      onChange={onChange}
      className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
    >
      <option value="">Select {label}</option>
      {options?.map((option) => (
        <option key={option} value={option}>
          {option}
        </option>
      ))}
    </select>
  </div>
);

export default Profile